import axios from 'axios';
import { handlePostWithResult } from '../../../../utils/AxiosUtil';

export const getCustomers = (customers) => {
    let names = [];
    /* eslint-disable array-callback-return */
    customers.map((item) => {
        names.push(item.value)
    });
    return names;
}

export const promiseCustomerOptions = async () => {
    const response = await axios.get('/api/outgoingbill/customers')
    const renamedCustomers = [];
    response.data.map((customer) =>
        renamedCustomers.push({
            label: customer.name,
            value: customer.privateId,
        }));
    return renamedCustomers;
};

export const handleCustomerSelected = (e, v, this2) => {
    let newValue;
    if (v) {
        newValue = v.find(element => element.inputValue);
        if (newValue) {
            const index = v.indexOf(newValue);
            v.splice(index, 1);
        }
    }
    if (newValue) {
        //new customer
        const path = '/api/outgoingbill/customer';
        const requestObject = { "name": newValue.inputValue };
        handlePostWithResult(path, requestObject, (res) => handleSuccessNewCustomer(v, newValue, res.privateId, this2), this2);
    } else {
        this2.setState({ selectedCustomers: v })
    }
}

export const handleSuccessNewCustomer = (array, newValue, id, this2) => {
    let newCustomer = {
        label: newValue.inputValue,
        value: id,
    }
    array.push(newCustomer);
    this2.setState({ selectedCustomers: array })
    newValue.label = newValue.inputValue;
}

export const handleStartDateChanged = (value, this2) => {
    const visible = isWithinLastNDaysOfMonth(value, 10);
    this2.setState({ startDate: value, firstTwoPhaseTogetherVisible: visible });
    console.log(visible);
    removeErrorMessage("paymentDeadline", this2);
}

function isWithinLastNDaysOfMonth(date, n) {
    const givenDate = new Date(date); // your date

    // Get the last day of the month
    const lastDayOfMonth = new Date(givenDate.getFullYear(), givenDate.getMonth() + 1, 0);

    // Start boundary = lastDayOfMonth - (n - 1) days
    const startDate = new Date(lastDayOfMonth);
    startDate.setDate(lastDayOfMonth.getDate() - (n - 1));

    return givenDate >= startDate && givenDate <= lastDayOfMonth;
}

export const removeErrorMessage = (name, this2) => {
    if (this2.state.errors.has(name)) {
        let copy = this2.state.errors;
        copy.delete(name);
        this2.setState({ errors: copy });
    }
}